export enum Auth {
    token_name = 'receptionist_token'
}

export enum Colors {
    PRIMARY = '#273D8B',
    SECONDARY = '#E8EDFF',
}